import { Checkout, ConsumerLookup } from '@afterpaytouch/portal-api/types'
import { CrossRegionRedirection } from '../../../model'
import { TrackingEvent } from '../../../model/monitoring'
import { determineRouteFromConsumerLookup, InitialiseNextRoute } from '../routing'
import { CheckoutAppDispatch } from '../../../state'

export interface ConsumerLookupRequest {
  checkout: Checkout
  consumerLookup: ConsumerLookup
  logEvent: (event: string, data?: Record<string, unknown>) => void
}

/**
 * Handles consumer lookup flow when checkout already contains consumer lookup data
 * This occurs when the user is recognized from previous sessions or other mechanisms
 */
export const handleConsolidatedConsumerLookup = (
  request: ConsumerLookupRequest,
  dispatch: CheckoutAppDispatch
): InitialiseNextRoute | CrossRegionRedirection => {
  const { checkout, consumerLookup, logEvent } = request

  // Log the consumer lookup data for analytics
  logEvent(TrackingEvent.GET_CHECKOUT_RETURN_LOOKUP_DATA, {
    cohort: consumerLookup.cohort,
    action: consumerLookup.action,
    cashtag: consumerLookup.cashtag,
    countryCode: consumerLookup.countryCode,
    redirectUrl: consumerLookup.redirectUrl,
    recognizedBy: consumerLookup.recognizedBy,
  })

  // Determine the appropriate route based on the consumer lookup data
  return determineRouteFromConsumerLookup(checkout.merchant.id, consumerLookup, dispatch)
}
